var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarOverlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93439 15.1925L16.0738 18.9036L14.4446 11.9092L19.8688 7.20325L12.7259 6.59635L9.93439 0L7.14282 6.59635L0 7.20325L5.42417 11.9092L3.79494 18.9036L9.93439 15.1925Z",
    fill: "#FFDF03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1978 28.5216L19.4829 32L19.6789 27.2159L24 25.1591L19.5187 23.4962L18.8973 18.7607L15.9317 22.5012L11.2347 21.6182L13.8835 25.6084L11.5939 29.8117L16.1978 28.5216Z",
    fill: "#FFDF03"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOverlay);
export default __webpack_public_path__ + "static/media/star-overlay.ef0352db94a37f0110de7ae239508d67.svg";
export { ForwardRef as ReactComponent };